import { useEffect, useState } from 'react'
import { Icon } from '@carrent/ui'

/**
 * Дерево страниц пространства.
 *
 * Ветки раскрываются по нажатию на треугольник, выбор страницы —
 * по нажатию на строку. Раскрытие и выбор разделены намеренно:
 * у раздела бывает и собственный текст, и потомки.
 */
export function PageTree({ nodes, activeId, onSelect, emptyHint }) {
  if (!nodes.length) {
    return <p className="kb-tree__empty">{emptyHint}</p>
  }
  return (
    <ul className="kb-tree" role="tree">
      {nodes.map((n) => (
        <TreeNode key={n.id} node={n} activeId={activeId} onSelect={onSelect} />
      ))}
    </ul>
  )
}

function TreeNode({ node, activeId, onSelect }) {
  const hasChildren = node.children.length > 0
  const containsActive = hasChildren && subtreeHas(node, activeId)
  const [open, setOpen] = useState(containsActive)

  // Переход по ссылке из поиска раскрывает ветку до найденной статьи.
  useEffect(() => {
    if (containsActive) setOpen(true)
  }, [containsActive])

  const active = node.id === activeId

  return (
    <li role="none">
      {/* Отступ уровня даёт вложенность разметки (см. .kb-tree ul в CSS),
          а не инлайновый стиль на каждой строке. */}
      <div className={`kb-tree__row${active ? ' is-active' : ''}`}>
        {hasChildren ? (
          <button
            type="button"
            className={`kb-tree__toggle${open ? ' is-open' : ''}`}
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? 'Свернуть раздел' : 'Развернуть раздел'}
            aria-expanded={open}
          >
            <Icon name="chevronRight" size={14} />
          </button>
        ) : (
          <span className="kb-tree__toggle kb-tree__toggle--leaf" aria-hidden="true" />
        )}

        <button
          type="button"
          role="treeitem"
          aria-selected={active}
          aria-current={active ? 'page' : undefined}
          className="kb-tree__link"
          onClick={() => onSelect(node)}
        >
          <span className="kb-tree__title">{node.title}</span>
          {node.pinned && (
            <Icon name="check" size={13} className="kb-tree__pin" title="Закреплена" />
          )}
          {node.status === 'draft' && <span className="kb-tree__flag">черновик</span>}
        </button>
      </div>

      {hasChildren && open && (
        <ul role="group">
          {node.children.map((c) => (
            <TreeNode key={c.id} node={c} activeId={activeId} onSelect={onSelect} />
          ))}
        </ul>
      )}
    </li>
  )
}

function subtreeHas(node, id) {
  if (id == null) return false
  return node.children.some((c) => c.id === id || subtreeHas(c, id))
}
